  <!-- <app-header class="header" [template]="'new-member'" [pageData]="{title: 'Add Member'}"></app-header>
  <div class="contentContainer"> -->
    <!-- <app-add-recipient-member-category-info
      [activeStepIndex]="'CATEGORYINFO'"
      (onStepChange)="onStepChange($event)">
    </app-add-recipient-member-category-info> -->
    <router-outlet></router-outlet>
  <!-- </div> -->
